export const adaptUsers = (users) => {
  return users?.map((user) => ({
    ...user,
    managerEmailId: user.manager?.emailId,
  }));
};
